module.exports = __webpack_public_path__ + "static/media/img-consumidor2.e9ef169e.e9ef169e.JPG";